import React, { createContext, useContext, useRef } from 'react';
import * as d3 from 'd3';

const GraphContext = createContext(null);

export const useGraphContext = () => useContext(GraphContext);

export const GraphProvider = ({ children }) => {
    const simulation = useRef(null);
    const g = useRef(null);
    const svg = useRef(null);
    const zoom = useRef(null);
    const lastTransform = useRef(d3.zoomIdentity.scale(0.8));
    const nodeParent = useRef(null);
    const linkParent = useRef(null);
    const labelParent = useRef(null);
    const expandButtonParent = useRef(null);
    const currentNode = useRef(null);

    const contextValue = {
        simulation,
        g,
        svg,
        zoom,
        lastTransform,
        nodeParent,
        linkParent,
        labelParent,
        expandButtonParent,
        currentNode
    };

    return (
        <GraphContext.Provider value={contextValue}>
            {children}
        </GraphContext.Provider>
    );
};
